import { reduxForm } from 'redux-form';
import Component from './FilterUserForm.jsx';
import validate from './validate';

const initialValues = {
  search: '',
};

const FilterUserForm = reduxForm({
  form: 'filterUserForm',
  initialValues,
  enableReinitialize: true,
  validate,
})(Component);

export default FilterUserForm;
